import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const containerStyle = {
  position: "relative",
  width: "100%",
  height: "400px", // Disabilita lo scroll verticale
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: true,
      text: "6-month projection",
    },
  },
};

const labels = [];

export const data = {
  labels,
  datasets: [],
};

const AreaChartComponent = (props) => {
  const chartData = props?.data ?? data;
  const chartOptions = props?.options ?? options;

  return (
    <div style={containerStyle}>
      <Line options={chartOptions} data={chartData} />
    </div>
  );
};

export default AreaChartComponent;
